
export function tagActionDetails() {
  return {
    restrict: 'E',
    template: require('./tag-action-details.directive.html'),
    scope: {
      action: "=",
      tagsGroups: "=",
    },
    controller: TagActionDetailsController
  };
}

TagActionDetailsController.$inject = ['$scope', 'UserFactory'];
function TagActionDetailsController($scope, UserFactory) {

  $scope.selectTagGroup = selectTagGroup;
  $scope.selectTag = selectTag;

  init();

  function selectTagGroup(tagGroup) {
    $scope.action.selectedTagGroup = tagGroup;
    $scope.action.tags = tagGroup.tags;
    $scope.action.selectedTag = tagGroup.tags[0];
  }

  function selectTag(tag) {
    $scope.action.selectedTag = tag;
  }

  function init() {
    let loggedUser = UserFactory.getLoggedUser();
    let lang = loggedUser.lang ? loggedUser.lang : 'en';
    $scope.action.selectedTagGroup = $scope.tagsGroups[0];

    if($scope.action.data && $scope.action.data.tagGroupId) {
      $scope.action.selectedTagGroup = $scope.tagsGroups.find(tg => tg.id === $scope.action.data.tagGroupId);
    }

    // Format tag groups and tag values nicely.
    for(let tagGroup of $scope.tagsGroups) {
      tagGroup.langName = tagGroup['name_' + lang] || tagGroup['name'];
      tagGroup.tags = tagGroup.tags_and_categories.filter(item => !item.is_category);
      tagGroup.tags.forEach(item => item.langName = item['name_' + lang]|| item['name']);
    }

    $scope.action.tags = $scope.action.selectedTagGroup.tags;
    $scope.action.selectedTag = $scope.action.tags[0];

    if($scope.action.data && $scope.action.data.tagId) {
      $scope.action.selectedTag = $scope.action.tags.find(t => t.id === $scope.action.data.tagId);
    }
  }
}
